import React from 'react';
import classNames from 'classnames';
import { Col } from 'shards-react';
import SidebarMainNavbar from './SidebarMainNavbar';
import SidebarNavItems from './SidebarNavItems';
import { connect } from 'react-redux';
import { toggleSidebar } from '../../../utils/redux/actions';

const MainSidebar = ({ dispatch, menuVisible, ...pathname }) => {
	const classes = classNames(
		'main-sidebar',
		'px-0',
		'd-none',
		'd-md-block',
		'position-fixed',
		'position-md-unset',
		menuVisible && 'open'
	);

	const handleToggleSidebar = () => {
		dispatch(toggleSidebar());
	};

	return (
		<Col tag='aside' className={classes}>
			<SidebarMainNavbar handleClick={handleToggleSidebar} />
			<SidebarNavItems {...pathname} />
		</Col>
	);
};

/**
 * Take the menuVisible variable saved in redux and return it
 * in components props.
 */
const mapStateToProps = ({ menuVisible }) => ({ menuVisible });

export default connect(mapStateToProps)(MainSidebar); //Export component and connect it with redux.
